import { defineWebModule } from '@portal/web-sdk';
import { manifest } from '../manifest.js';
import { en, vi } from './translations.js';

export const attendanceWebModule = defineWebModule({
  manifest,
  translations: { vi, en },
  routes: [
    { path: '/attendance', component: () => import('./pages/MyAttendancePage.js') },
    { path: '/attendance/board', component: () => import('./pages/BoardPage.js') },
    { path: '/attendance/people/$employeeId', component: () => import('./pages/PersonPage.js') },
    { path: '/attendance/devices', component: () => import('./pages/DevicesPage.js') },
  ],
});
